import HttpRequest from './HttpRequest'

class ProportionContactChannelsChennelProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-contact-channels-channel/', query)
  }
}

export default ProportionContactChannelsChennelProvider
